import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux/es/exports";
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from "react-i18next";
import {VscSaveAs} from "react-icons/vsc";
import {toast} from "react-toastify";
import {getAccessoryById, getList, getProfileType} from "../../../services/accessoryService";
import Button from "../../../components/Button";
import ComboboxComponent from "../../../components/Combobox";
import {saveSupplier} from "../../../services/supplierService";
import {deleteItem} from "../../../services/service";
import TranslationTable from "../../../components/TranslationTable";

const ACCESSORIES_TRANSLATION_FIELDS = [
    {key: "NAME", label: "Nomi (name)"},
    {key: "NAME_IN_CATALOG", label: "Katalog nomi (nameInCatalog)"},
];

const HANDLE_BASE_URL = "https://oss.windowcc.com/imge/hardware/";
const HANDLE_IMAGES = [
    "Handle", "Handle6", "Handle11", "Handle2", "Handle3", "Handle5", "Handle8",
    "Handle12", "Handle9", "Handle7", "Handle4", "Handle10",
    "CommercialHandle", "CommercialHandle2", "CommercialHandle3", "CommercialHandle4",
    "CommercialHandle5", "CommercialHandle6", "CommercialHandle7", "CommercialHandle8",
    "CommercialHandle9", "CommercialHandle10",
].map((file) => `${HANDLE_BASE_URL}${file}.png`);

const getHandleName = (url) => url.substring(url.lastIndexOf("/") + 1).replace(/\.[^.]+$/, "");


function AddAccessoriesType({t}) {
    const {token} = useSelector((state) => state.user);
    const [types, setTypes] = useState([]);
    const [subTypes, setSubTypes] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [units, setUnits] = useState([]);
    const navigate = useNavigate();
    const translationRef = useRef(null);

    const [open, setOpen] = useState(false);

    const [image, setImage] = useState({
        preview:
            "https://e7.pngegg.com/pngimages/641/399/png-clipart-upload-directory-document-document-file-up-upload-icon-miscellaneous-angle.png",
        data: null,
    });
    const {id} = useParams();

    const [formData, setFormData] = useState({
        id: id ? id : null,
        name: "",
        nameInCatalog: "",
        article: "",
        articleSpecificWeight: "",
        drawingId: null,
        unitId: null,
        unitName: "",
        supplierId: null,
        supplierName: "",
        profileType: "",
        subtype: "",
        handleType: "",
    });
    useEffect(() => {
        let urlTypes = `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/enum/article/type/${'ACCESSORIES'}`;
        let urlSubTypes = `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/enum/article/subtype`;
        let urlUnitList = `${process.env.REACT_APP_HOST_BASE_URL}/v1/unit/list`;
        let urlSupplierList = `${process.env.REACT_APP_HOST_BASE_URL}/v1/supplier/list`;
        (async () => {
            let jsonTypes = await getProfileType(urlTypes, token);
            if (jsonTypes.success) {
                setTypes(
                    jsonTypes.res.map((item) => {
                        return {
                            id: item.id,
                            name: t(`${item.name}`),
                            value: item.name
                        };
                    })
                )
            }
            let jsonSubTypes = await getProfileType(urlSubTypes, token);
            if (jsonSubTypes.success) {
                setSubTypes(
                    jsonSubTypes.res.map((item) => {
                        return {
                            id: item.id,
                            name: t(`${item.name}`),
                            value: item.name
                        };
                    })
                )
            }
            let jsonUnit = await getList(urlUnitList, token);
            if (jsonUnit.success) {
                setUnits(jsonUnit.res);
            }
            let jsonSupplier = await getList(urlSupplierList, token);
            if (jsonSupplier.success) {
                setSuppliers(jsonSupplier.res);
            }
        })();
    }, [id, token, open]);

    useEffect(() => {
    }, [units, types, suppliers]);

    useEffect(() => {
        if (id) {
            (async () => {
                let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/${id}`;
                let json = await getAccessoryById(url, token);
                if (json.success) {
                    if (json.res.drawingId) {
                        setImage({
                            preview: `${process.env.REACT_APP_HOST_BASE_URL}/v1/file/product/${json.res.drawingId}`,
                            data: null,
                        });
                    }
                    setFormData({
                        id: json.res.id,
                        name: json.res.name,
                        nameInCatalog: json.res.nameInCatalog,
                        article: json.res.article,
                        articleSpecificWeight: json.res.articleSpecificWeight,
                        drawingId: json.res.drawingId,
                        unitId: json.res.unitId,
                        unitName: json.res.unitName,
                        supplierId: json.res.supplierId,
                        supplierName: json.res.supplierName,
                        profileType: json.res.profileType,
                        subtype: json.res.subtype,
                        handleType: json.res.handleType,
                    });
                }
            })();
        }
    }, [id, token, open]);

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/accessories`;
        console.log('formData',formData);
        let formDataObj = id
            ? {
                id: id ? id : null,
                name: evt.target.name.value.trim(),
                nameInCatalog: evt.target.nameInCatalog.value.trim(),
                article: evt.target.article.value.trim(),
                articleSpecificWeight: evt.target.articleSpecificWeight.value.trim(),
                drawingId: formData.drawingId,
                unitId: formData.unitId,
                unitName: formData.unitName,
                supplierId: formData.supplierId,
                supplierName: formData.supplierName,
                profileType: formData.profileType,
                subtype: formData.profileType === 'FITTINGS' ? formData.subtype : null,
                handleType: formData.subtype === 'HANDLE' ? formData.handleType : null,
            }
            : {
                id: null,
                name: evt.target.name.value.trim(),
                nameInCatalog: evt.target.nameInCatalog.value.trim(),
                article: evt.target.article.value.trim(),
                articleSpecificWeight: evt.target.articleSpecificWeight.value.trim(),
                drawingId: formData.drawingId,
                unitId: formData.unitId,
                unitName: formData.unitName,
                supplierId: formData.supplierId,
                supplierName: formData.supplierName,
                profileType: formData.profileType,
                subtype: formData.profileType === 'FITTINGS' ? formData.subtype : null,
                handleType: formData.subtype === 'HANDLE' ? formData.handleType : null,
            };
        const response = await saveSupplier(url, token, formDataObj, image.data);
        if (response.success) {
            if (response.status === 206) {
                toast.warn(response.data.error, {
                    position: "bottom-right",
                    autoClose: 5000,
                    closeOnClick: true,
                    className: "product-background",
                    pauseOnHover: true,
                });
            } else {
                const entityId = id ? parseInt(id) : response.data?.id;
                if (translationRef.current && entityId) {
                    try {
                        await translationRef.current.save(entityId);
                    } catch (err) {
                        toast.error(t("action.translation_save_error"), {
                            position: "bottom-right",
                            autoClose: 5000,
                            closeOnClick: true,
                        });
                        return;
                    }
                }
                navigate(`/product/accessories`);
                toast.success(id ? t('action.edit_success') : t('action.add_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            }
        } else {
            navigate("/error", {
                state: {
                    status: response.status, message: response.body ? response.body.error : "Error",
                },
            });
        }
    };

    const onChangeType = (value) => {
        setFormData({...formData, profileType: value.value});
    };

    const onChangeSubType = (value) => {
        setFormData({...formData, subtype: value.value});
    };

    const onChangeUnit = (value) => {
        setFormData({...formData, unitId: value.id, unitName: value.name});
    };
    const onChangeHandleType = (name) => {
        setFormData({...formData, handleType: name});
    };

    const onChangeSupplier = (value) => {
        setFormData({
            ...formData,
            supplierId: value.id,
            supplierName: value.name,
        });
    };

    const handleFileChange = (e) => {
        setImage({
            preview: URL.createObjectURL(e.target.files[0]),
            data: e.target.files[0],
        });
    };

    return (
        <>
            <div className="px-4 py-4 sm:px-6 lg:px-8">
                <h1 className="mb-5 text-xl font-semibold text-gray-900">
                    {id ? t(`update_accessories`) : t(`add_accessories`)}
                </h1>
                <form onSubmit={handleSubmit}>
                    <div className="overflow-hidden shadow sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                            <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-2">
                                    <label
                                        htmlFor="name"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t(`name`)}
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        required
                                        autoComplete="name"
                                        defaultValue={formData.name}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>

                                <div className="col-span-6 sm:col-span-2">
                                    <label
                                        htmlFor="nameInCatalog"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t(`directory_name`)}
                                    </label>
                                    <input
                                        type="text"
                                        name="nameInCatalog"
                                        id="nameInCatalog"
                                        required
                                        autoComplete="nameInCatalog"
                                        defaultValue={formData.nameInCatalog}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-2">
                                    <label
                                        htmlFor="article"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t(`article`)}
                                    </label>
                                    <input
                                        type="text"
                                        name="article"
                                        id="article"
                                        required
                                        autoComplete="article"
                                        defaultValue={formData.article}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>

                                <div className="col-span-6 sm:col-span-2">
                                    <ComboboxComponent
                                        data={types}
                                        label={t(`type`)}
                                        item={
                                            formData.profileType
                                                ? types.find(
                                                    (item) => item.value === formData.profileType
                                                )
                                                : null
                                        }
                                        onChange={onChangeType}
                                    />
                                </div>
                                {formData.profileType === 'FITTINGS' ?
                                    <div className="col-span-6 sm:col-span-2">
                                        <ComboboxComponent
                                            data={subTypes}
                                            label={t(`subtype`)}
                                            item={
                                                formData.subtype
                                                    ? subTypes.find(
                                                        (item) => item.value === formData.subtype
                                                    )
                                                    : null
                                            }
                                            onChange={onChangeSubType}
                                        />
                                    </div> : ''
                                }

                                <div className="col-span-6 sm:col-span-2">
                                    <ComboboxComponent
                                      data={units}
                                      label={t(`unit`)}
                                      item={
                                          formData.unitId
                                            ? units.find((item) => item.id === formData.unitId)
                                            : null
                                      }
                                      onChange={onChangeUnit}
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-2">
                                    <ComboboxComponent
                                      data={suppliers}
                                      label={t(`supplier`)}
                                      item={
                                          formData.supplierId
                                                ? suppliers.find(
                                                    (item) => item.id === formData.supplierId
                                                )
                                                : null
                                        }
                                        onChange={onChangeSupplier}
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-2">
                                    <label
                                        htmlFor="articleSpecificWeight"
                                        className="block text-sm font-medium text-gray-700 mb-3"
                                    >
                                        {t(`articleSpecificWeight`)}
                                    </label>
                                    <input
                                        type="number"
                                        name="articleSpecificWeight"
                                        id="articleSpecificWeight"
                                        step={0.001}
                                        autoComplete="articleSpecificWeight"
                                        defaultValue={formData.articleSpecificWeight}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                                {formData.subtype === 'HANDLE' ?
                                    <div className="col-span-6">
                                        <label className="block text-sm font-medium text-gray-700">
                                            {t(`handleType`)}
                                        </label>
                                        <div className="flex gap-3 pb-2 mt-2 overflow-x-auto">
                                            {HANDLE_IMAGES.map((url) => {
                                                const name = getHandleName(url);
                                                const active = formData.handleType === name;
                                                return (
                                                    <button
                                                        type="button"
                                                        key={name}
                                                        title={name}
                                                        onClick={() => onChangeHandleType(name)}
                                                        className={`flex flex-col items-center flex-shrink-0 w-24 p-2 bg-white border-2 rounded-md ${active ? "border-indigo-600 ring-2 ring-indigo-300" : "border-gray-200 hover:border-indigo-300"}`}
                                                    >
                                                        <img src={url} alt={name} className="object-contain w-full h-24"/>
                                                        <span className="w-full mt-1 text-xs text-center text-gray-600 truncate">{name}</span>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div> : ''
                                }
                                <TranslationTable
                                    ref={translationRef}
                                    entityType="PRODUCT"
                                    entityId={id ? parseInt(id) : null}
                                    fields={ACCESSORIES_TRANSLATION_FIELDS}
                                    defaultValues={{
                                        NAME: formData.name,
                                        NAME_IN_CATALOG: formData.nameInCatalog,
                                    }}
                                />

                                <div className="col-span-6 sm:col-span-6 ">
                                    <label
                                        htmlFor="drawing"
                                        className="block pb-2 text-sm font-medium text-gray-700"
                                    >
                                        {t(`drawing`)}
                                    </label>
                                    <div
                                        className="flex justify-center w-full pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                                        <div className="space-y-1 text-center">
                                            <div className="flex justify-center mb-2">
                                                <img
                                                    src={image.preview}
                                                    className="rounded-lg"
                                                    width="100px"
                                                    height="50px"
                                                    alt="texturesimage"
                                                />
                                            </div>
                                            <div className="flex text-sm text-gray-600">
                                                <label
                                                    htmlFor="drawing"
                                                    className="relative font-medium text-indigo-600 bg-white rounded-md cursor-pointer hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                                                >
                                                    <span>{t(`upload_file`)}</span>
                                                    {formData.drawingId ? (
                                                        <input
                                                            id="drawing"
                                                            name="file-upload"
                                                            type="file"
                                                            className="sr-only"
                                                            onChange={handleFileChange}
                                                        />
                                                    ) : (
                                                        <input
                                                            id="drawing"
                                                            name="file-upload"
                                                            type="file"
                                                            className="sr-only"
                                                            onChange={handleFileChange}
                                                        />
                                                    )}
                                                </label>
                                                <p className="pl-1">{t(`upload_file_text1`)}</p>
                                            </div>
                                            <p className="text-xs text-gray-500">
                                                {t(`upload_file_text2`)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end px-4 py-3 text-right bg-gray-50 sm:px-6">
                            <Button type="button" to="/product/accessories" btnName={t(`backward`)}/>
                            <button
                                type="submit"
                                className="flex items-center justify-center px-4 py-1 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                                {t(`save`)}
                                <VscSaveAs className="w-4 h-4 ml-1"/>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default withTranslation()(AddAccessoriesType);
